<template>
  <div
    class="table-responsive table-content"
    :class="{ 'table-columns-fixed': fixedColumns }"
  >
    <table class="table-bordered">
      <slot />
    </table>
  </div>
</template>

<script>
export default {
  props: {
    fixedColumns: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  min-width: 100%;
  table-layout: fixed;
}

th:first-child,
td:first-child,
td:nth-child(2),
th:nth-child(2) {
  background-color: #f2f2f2;
}

.table-content {
  white-space: nowrap;
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 1rem;
  height: 100%;
  overflow-x: auto;
  overflow-y: auto;
  flex-grow: 1;
}

.table-content table thead {
  position: sticky;
  top: 0px;
  z-index: 1;
  background-color: #fff;
  border-right: 1px solid gray;
  height: 50px;
}

.table-content thead {
  border-bottom: 3px solid gray;
}

.table-content thead tr {
  font-weight: bold;
}

.table-content table tbody {
  margin-top: 2rem;
}

.table-content .table-bordered {
  table-layout: fixed;
  border-collapse: collapse;

  > tr,
  td,
  th {
    padding: 0rem 0.5rem 0rem 0.5rem;
    height: 45px;
    word-wrap: break-word;
    white-space: nowrap;
  }
}

.table-columns-fixed {
  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 6rem;
  }
}

@media (max-height: 768px) {
  .table-content {
    height: 25rem;
  }
}

@media (max-height: 1440px) {
  .table-content {
    height: 65vh;
  }
}
</style>
